import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import axios from "axios";

export default function FeePieChart() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [data, setData] = useState(null);
  const session = localStorage.getItem("currentSessionId");

  const getMonthYear = () => {
    const today = new Date();
    return today.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
    });
  };

  useEffect(() => {
    const fetchFeeData = async () => {
      try {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();

        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/fees/report/monthly-summary`,
          { params: { sessionId: session, month, year } }
        );

        const { totalPaid = 0, totalDue = 0 } = res.data || {};
        setData({ deposited: totalPaid, pending: totalDue });
      } catch (err) {
        console.error(err);
        setData({ deposited: 0, pending: 0 });
      }
    };

    fetchFeeData();
  }, [session]);

  useEffect(() => {
    if (!data || !chartRef.current) return;

    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }

    chartInstance.current.setOption({
      title: {
        text: `Fee Deposited (${getMonthYear()})`,
        left: "center",
        textStyle: { fontSize: 14, fontWeight: "bold" },
      },
      tooltip: { trigger: "item" },
      series: [
        {
          name: "Fee Status",
          type: "pie",
          radius: "45%",
          data: [
            { value: data.deposited, name: "Deposited" },
            { value: data.pending, name: "Pending" },
          ],
          color: ["#42A5F5", "#FFA726"],
          emphasis: {
            itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.4)" },
          },
        },
      ],
    });
  }, [data]);

  return   <div
        ref={chartRef}
        style={{
          width: "100%",
          height: "250px",
          background: "#fff",
          borderRadius: "10px",
          padding: "10px",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        }}
      />
}
